import { v4 as uuid } from 'uuid';

import type { Doctor, Medication } from 'src/app/types';

export const EMPTY_MEDICATION: Medication = {
  id: uuid(),
  name: '',
  attributes: {},
};

export const EMPTY_DOCTOR: Doctor = {
  id: uuid(),
  name: '',
  phone: '',
  isPhoneShown: false,
  medications: [EMPTY_MEDICATION],
  npi: '',
};
